module.exports = __webpack_public_path__ + "static/noimage-8a9f399cfaaa75f1f8b1b1072637b082.png";